import { Box, Container, Hidden, Typography, Tooltip } from "@material-ui/core";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import Waves from "../../../assets/staticAssets/Waves.svg";
// import WavesWhite from "../../../assets/staticAssets/WavesWhite.svg";
import React from "react";
import { useHistory, Link } from "react-router-dom";
import EndCredits from "../EndCredits/EndCredits";
import { FaTwitter } from "react-icons/fa";
// import { GrFacebook } from "react-icons/gr";
import facebook from "../../../assets/staticAssets/facebook.svg";
import instagram from "../../../assets/staticAssets/instagram.svg";
import telegram from "../../../assets/staticAssets/telegram.svg";
import { SiLinkedin } from "react-icons/si";
import { SiYoutube } from "react-icons/si";
import googleplay from "../../../assets/staticAssets/googleplay.png";

function FooterWithContent() {
  const classes = useStyles();
  const theme = useTheme();
  let history = useHistory();

  return (
    <Box
      id="contact-us"
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      style={{
        position: "relative",
        bottom: 0,
      }}
      className={classes.borderFooter}
    >
      {/* <Hidden xsDown>
        <img src={Waves} alt="waves-bg" className={classes.rootImg} />
      </Hidden> */}
      <Container maxWidth="lg">
        <Box
          display="flex"
          flexDirection="column"
          justifyContent="space-evenly"
          className={classes.root}
        >
          {/* <Box
            display="flex"
            flexDirection="column"
            justifyContent="space-around"
            className={classes.topBox}
          >
            <Typography variant="h5" className={classes.typographyAdjustment}>
              Explore the future of money
            </Typography>
            <Typography variant="h3" style={{ color: "#3AC4AB" }}>
              10,4434{" "}
              <span style={{ fontSize: "15px", color: "white" }}>
                Signed up
              </span>
            </Typography>
          </Box> */}

          <Hidden smDown>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                marginTop: "30px",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  flexWrap: "wrap",
                }}
              >
                <img
                  className={classes.mediaIcon}
                  src={googleplay}
                  alt="googleplay"
                  style={{ height: "50px", marginRight: "50px" }}
                  onClick={() => {
                    window.open(
                      "https://play.google.com/store/apps/details?id=com.pocketbits",
                      "_blank",
                      "nofollow,noopener,noreferrer"
                    );
                  }}
                />
                <p style={{ fontSize: "18px", marginRight: "10px" }}>
                  Follow us on:
                </p>
                <FaTwitter
                  className={classes.mediaIcon}
                  style={{
                    fontSize: 42,
                    color: "#1DA1F2",
                    marginLeft: "10px",
                    marginRight: "10px",
                  }}
                  onClick={() => {
                    window.open(
                      "https://twitter.com/PocketBitsIndia",
                      "_blank",
                      "nofollow,noopener,noreferrer"
                    );
                  }}
                />
                <img
                  className={classes.mediaIcon}
                  src={facebook}
                  alt="fb"
                  style={{ marginLeft: "10px", marginRight: "10px" }}
                  onClick={() => {
                    window.open(
                      "https://www.facebook.com/Pocketbits.in",
                      "_blank",
                      "nofollow,noopener,noreferrer"
                    );
                  }}
                />
                <img
                  className={classes.mediaIcon}
                  src={instagram}
                  alt="instagram"
                  style={{
                    marginLeft: "10px",
                    marginRight: "10px",
                    transform: "scale(0.79)",
                  }}
                  onClick={() => {
                    window.open(
                      "https://www.instagram.com/pocketbits.in/",
                      "_blank",
                      "nofollow,noopener,noreferrer"
                    );
                  }}
                />
                <img
                  className={classes.mediaIcon}
                  src={telegram}
                  alt="telegram"
                  style={{ marginLeft: "10px", marginRight: "10px" }}
                  onClick={() => {
                    window.open(
                      "https://t.me/pocketbits",
                      "_blank",
                      "nofollow,noopener,noreferrer"
                    );
                  }}
                />
                <SiLinkedin
                  className={classes.mediaIcon}
                  style={{
                    fontSize: 42,
                    color: "#2867B2",
                    marginLeft: "10px",
                    marginRight: "10px",
                  }}
                  onClick={() => {
                    window.open(
                      "https://www.linkedin.com/company/13242459",
                      "_blank",
                      "nofollow,noopener,noreferrer"
                    );
                  }}
                />
                <SiYoutube
                  className={classes.mediaIcon}
                  style={{
                    fontSize: 42,
                    color: "#C62D2B",
                    marginLeft: "10px",
                    marginRight: "10px",
                  }}
                  onClick={() => {
                    window.open(
                      "https://www.youtube.com/channel/UC1JBJkM7V-jmylPYtSnPmqw",
                      "_blank",
                      "nofollow,noopener,noreferrer"
                    );
                  }}
                />
              </div>
            </div>
          </Hidden>

          <Hidden mdUp>
            <div style={{ marginTop: "30px" }}>
              <img
                className={classes.mediaIcon}
                src={googleplay}
                alt="googleplay"
                style={{ height: "50px", marginRight: "45px" }}
                onClick={() => {
                  window.open(
                    "https://play.google.com/store/apps/details?id=com.pocketbits",
                    "_blank",
                    "nofollow,noopener,noreferrer"
                  );
                }}
              />
            </div>
            <p
              style={{
                fontSize: "18px",
                marginRight: "10px",
                marginTop: "18px",
              }}
            >
              Follow us on:
            </p>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                flexWrap: "wrap",
                // marginBottom: "30px",
              }}
            >
              <FaTwitter
                className={classes.mediaIcon}
                style={{
                  fontSize: 28,
                  color: "#1DA1F2",
                  marginLeft: "10px",
                  // marginRight: "10px",
                }}
                onClick={() => {
                  window.open(
                    "https://twitter.com/PocketBitsIndia",
                    "_blank",
                    "nofollow,noopener,noreferrer"
                  );
                }}
              />
              <img
                className={classes.mediaIcon}
                src={facebook}
                alt="fb"
                style={{
                  marginLeft: "10px",
                  // marginRight: "10px",
                  transform: "scale(0.7)",
                }}
                onClick={() => {
                  window.open(
                    "https://www.facebook.com/Pocketbits.in",
                    "_blank",
                    "nofollow,noopener,noreferrer"
                  );
                }}
              />
              <img
                className={classes.mediaIcon}
                src={instagram}
                alt="instagram"
                style={{
                  // marginLeft: "10px",
                  // marginRight: "10px",
                  transform: "scale(0.5)",
                }}
                onClick={() => {
                  window.open(
                    "https://www.instagram.com/pocketbits.in/",
                    "_blank",
                    "nofollow,noopener,noreferrer"
                  );
                }}
              />
              <img
                className={classes.mediaIcon}
                src={telegram}
                alt="telegram"
                style={{
                  // marginLeft: "10px",
                  marginRight: "10px",
                  transform: "scale(0.65)",
                }}
                onClick={() => {
                  window.open(
                    "https://t.me/pocketbits",
                    "_blank",
                    "nofollow,noopener,noreferrer"
                  );
                }}
              />
              <SiLinkedin
                className={classes.mediaIcon}
                style={{
                  fontSize: 28,
                  color: "#2867B2",
                  marginLeft: "8px",
                  marginRight: "10px",
                }}
                onClick={() => {
                  window.open(
                    "https://www.linkedin.com/company/13242459",
                    "_blank",
                    "nofollow,noopener,noreferrer"
                  );
                }}
              />
              <SiYoutube
                className={classes.mediaIcon}
                style={{
                  fontSize: 28,
                  color: "#C62D2B",
                  marginLeft: "10px",
                  marginRight: "10px",
                }}
                onClick={() => {
                  window.open(
                    "https://www.youtube.com/channel/UC1JBJkM7V-jmylPYtSnPmqw",
                    "_blank",
                    "nofollow,noopener,noreferrer"
                  );
                }}
              />
            </div>
          </Hidden>

          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            flexWrap="wrap"
            className={classes.bottomBox}
          >
            <div className={classes.column}>
              <Typography variant="h5">
                <strong>Company</strong>
              </Typography>
              <Typography
                variant="h6"
                className={classes.listItems}
                // onClick={() => {
                //   history.push(`/aboutus`);
                // }}
              >
                <Link
                  to={`/aboutus`}
                  style={{ color: theme.palette.text.primary }}
                >
                  About Us
                </Link>
              </Typography>
              <Typography
                variant="h6"
                className={classes.listItems}
                onClick={() => {
                  window.open(
                    "https://pocketbits.in/blog/",
                    "_blank",
                    "nofollow,noopener,noreferrer"
                  );
                }}
              >
                Blog
              </Typography>
              <Typography
                variant="h6"
                className={classes.listItems}
                // onClick={() => {
                //   history.push(`/feespage`);
                // }}
              >
                <Link
                  to={`/feespage`}
                  style={{ color: theme.palette.text.primary }}
                >
                  Fee Structure
                </Link>
              </Typography>
              <Typography
                variant="h6"
                className={classes.listItems}
                // onClick={() => {
                //   history.push(`/tandc`);
                // }}
              >
                <Link
                  to={`/tandc`}
                  style={{ color: theme.palette.text.primary }}
                >
                  Terms & Conditions
                </Link>
              </Typography>
              <Typography
                variant="h6"
                className={classes.listItems}
                // onClick={() => {
                //   history.push(`/privacy`);
                // }}
              >
                <Link
                  to={`/privacy`}
                  style={{ color: theme.palette.text.primary }}
                >
                  Privacy Policy
                </Link>
              </Typography>
              <Typography
                variant="h6"
                className={classes.listItems}
                // onClick={() => {
                //   history.push(`/aml`);
                // }}
              >
                <Link to={`/aml`} style={{ color: theme.palette.text.primary }}>
                  AML & KYC
                </Link>
              </Typography>
            </div>
            <div className={classes.column}>
              <Typography
                variant="h6"
                className={classes.listItems}
                // onClick={() => {
                //   history.push(`/careers`);
                // }}
              >
                <Link
                  to={`/careers`}
                  style={{ color: theme.palette.text.primary }}
                >
                  We are Hiring
                </Link>
              </Typography>
              {/* <Typography
                variant="h6"
                className={classes.listItems}
                // onClick={() => {
                //   history.push(`/bugbounty`);
                // }}
              >
                <Link
                  to={`/bugbounty`}
                  style={{ color: theme.palette.text.primary }}
                >
                  Bug Bounty Program
                </Link>
              </Typography> */}
              <Typography variant="h6" className={classes.listItems}>
                <Tooltip title="Coming soon" placement="bottom">
                  <span>Low Latency API</span>
                </Tooltip>
              </Typography>
              <Typography variant="h6" className={classes.listItems}>
                Site Updates
              </Typography>
            </div>
            <div className={classes.column}>
              <Typography variant="h5">
                <strong>Support</strong>
              </Typography>
              <Typography
                variant="h6"
                className={classes.listItems}
                // onClick={() => {
                //   history.push(`/contactus`);
                // }}
              >
                <Link
                  to={`/contactus`}
                  style={{ color: theme.palette.text.primary }}
                >
                  Contact Us
                </Link>
              </Typography>
              <Typography
                variant="body1"
                className={classes.listItems}
                onClick={() => {
                  window.fcWidget.open();
                  window.fcWidget.show();
                }}
              >
                Chat With Us
              </Typography>
              <Typography
                variant="body1"
                className={classes.listItems}
                onClick={() => {
                  window.open(
                    "https://support.pocketbits.in/support/solutions",
                    "_blank",
                    "nofollow,noopener,noreferrer"
                  );
                }}
              >
                Support Center
              </Typography>
              <Typography
                variant="body1"
                className={classes.listItems}
                onClick={() => {
                  window.open(
                    "https://support.pocketbits.in/support/tickets/new",
                    "_blank",
                    "nofollow,noopener,noreferrer"
                  );
                }}
              >
                Create a Support Ticket
              </Typography>
            </div>
            <div className={classes.column}>
              <Typography
                variant="body1"
                className={classes.listItems}
                onClick={() => {
                  window.open(
                    "https://mail.google.com/mail/u/0/?fs=1&tf=cm&source=mailto&to=alliance@pocketbits.in",
                    "_blank",
                    "nofollow,noopener,noreferrer"
                  );
                }}
              >
                Partnership Queries
              </Typography>
              <Typography
                variant="body1"
                className={classes.listItems}
                onClick={() => {
                  window.open(
                    "https://mail.google.com/mail/u/0/?fs=1&tf=cm&source=mailto&to=alliance@pocketbits.in",
                    "_blank",
                    "nofollow,noopener,noreferrer"
                  );
                }}
              >
                Coin Listing request
              </Typography>
              <Typography variant="body1" className={classes.listItems}>
                <Tooltip title="Coming soon" placement="bottom">
                  <span>Media Assets</span>
                </Tooltip>
              </Typography>
            </div>
          </Box>
        </Box>
        <div className={classes.endCredits}>
          <EndCredits></EndCredits>
        </div>
      </Container>
    </Box>
  );
}
export default FooterWithContent;

const useStyles = makeStyles((theme) => {
  return {
    rootImg: {
      //   [theme.breakpoints.up("lg")]: {
      //     transform: "translateY(-10%)",
      //   },

      //   [theme.breakpoints.up("sm")]: {
      //     transform: "translateY(-20%)",
      //   },
      [theme.breakpoints.down("sm")]: {
        transform: "translateY(-28%)",
      },
      [theme.breakpoints.up("md")]: {
        transform: "translateY(-20%)",
      },
      [theme.breakpoints.up("lg")]: {
        transform: "translateY(0%)",
      },
      [theme.breakpoints.width]: {},

      // width: "130vw",
      position: "absolute",

      // zIndex: "-99",
      // left: "-18%",
      top: "0",
    },
    root: {
      color: "#fff",
      // minHeight: "70vh",
      width: "100%",
    },
    topBox: {
      height: "15vh",
      minWidth: "20%",
    },
    bottomBox: {
      // height: "50vh",
      padding: "50px 0px",
      alignSelf: "stretch",
    },
    listItems: {
      fontWeight: 100,
      lineHeight: "35px",
      "&:hover": {
        cursor: "pointer",
        textDecoration: "underline",
      },
    },
    column: {
      padding: "10px 10px",
    },
    borderFooter: {
      backgroundImage: `url('${Waves}')`,
      backgroundRepeat: "no-repeat",
      backgroundSize: "140vw 100vh",
      backgroundPosition: "-200px 150px",

      [theme.breakpoints.down("sm")]: {
        backgroundPosition: "-100px 150px",
      },
      [theme.breakpoints.down("xs")]: {
        borderTop: "4px solid #3AC4AB",
        // paddingBottom: "165px",
      },
    },
    endCredits: {
      marginTop: "80px",
    },
    mediaIcon: {
      "&:hover": {
        cursor: "pointer",
      },
    },
  };
});
